import tableReport from '@/components/reports/TableReport.vue'
import contactSalesSummaryReport from '@/components/reports/ContactSalesSummaryReport.vue'
import productionReceivedReport from '@/components/reports/ProductionReceivedReport.vue'
import receivedDetailReport from '@/components/reports/ReceivedDetailReport.vue'
import budgetReport from '@/components/reports/BudgetReport.vue'
export default {
    definitions: [
        {
            code: 'wip-powder',
            title: 'WIP Powder Report',
            subtitle: 'Shows estimated powder requirements for all WIP jobs.',
            component: tableReport,
            route: '/report/wippowder',
            accessLevel: 0
        },
        {
            code: 'rework-summary',
            title: 'Weekly Rework Summary',
            subtitle: 'Shows a week summary view of reworks.',
            route: '/report/weeklyreworksumm',
            accessLevel: 15
        },
        {
            code: 'contact-sales-sum',
            title: 'Contact Sales Summary',
            subtitle: 'Shows summary of sales list for a period by contact.',
            component: contactSalesSummaryReport,
            route: '/report/contactsalessum',
            accessLevel: 15
        },
        {
            code: 'weekly-production-summary',
            title: 'Weekly Production Summary',
            subtitle: 'Shows a week summary view of production.',
            route: '/report/weeklyprodsumm',
            accessLevel: 15
        },
        {
            code: 'production-received',
            title: 'Production/Received',
            subtitle: 'Shows a line graph of production vs received',
            component: productionReceivedReport,
            route: '/report/productionreceived',
            accessLevel: 0
        },
        {
            code: 'weekly-received-detail',
            title: 'Received Detail',
            subtitle: 'Shows a detailed view of received by customer.',
            component: receivedDetailReport,
            route: '/report/receiveddetail',
            accessLevel: 0
        },
        {
            code: 'budget-report',
            title: 'Budget Report',
            subtitle: 'Shows break down of yearly budget across the customer base.',
            component: budgetReport,
            route: '/report/budgetdetail',
            accessLevel: 15
        },
        {
            code: 'production-time',
            title: 'Production Time Report',
            subtitle: 'Shows break down of production times over a given time period',
            route: '/report/productiontime',
            accessLevel: 0
        },
        {
            code: 'job-item-search',
            title: 'Job Item Search',
            subtitle: 'Search job item descriptions across jobs.',
            route: '/report/jobitemsearch',
            accessLevel: 0
        }
    ]
}